import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import NavigationDrawer from "../../../components/NavigationDrawer";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import ContentList from "./list";
import GenerateContent from "./generate";
import BrandProfiles from "./brandProfiles";
import AnalyticsDashboard from "./analytics";
import AutomationSchedules from "./automation";

const tabs = [
  { label: "Content List", value: "content_list" },
  { label: "Generate Content", value: "generate_content" },
  { label: "Brand Profiles", value: "brand_profiles" },
];

function ContentHub() {
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.activeTab.tabs);

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, contentHub: tab }));
  };

  const renderTabContent = () => {
    switch (activeTab.contentHub) {
      case "generate_content":
        return <GenerateContent handleChangeTab={handleChangeTab} />;
      case "brand_profiles":
        return <BrandProfiles handleChangeTab={handleChangeTab} />;
      case "automation":
        return <AutomationSchedules />;
      case "analytics":
        return <AnalyticsDashboard />;
      case "content_list":
      default:
        return <ContentList handleChangeTab={handleChangeTab} />;
    }
  };

  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading="Content Hub"
            tabs={tabs}
            activeTab={activeTab.contentHub || "content_list"}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {renderTabContent()}
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default ContentHub;
